<ng-container *ngIf="modalType == _assignmentsService.modalTypes.assignToMeModal">
  <div class="modal-dialog modal-md m-0" style="max-width: 100% !important;">
    <div class="modal-content border-0">
      <form [formGroup]="assignToMeForm" (ngSubmit)="handleAssignToMe()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18 pt-2">Assign to Me</h4>
      <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
      </div>
        <div class="modal-body bg-white">
          <p>Are you sure you want to assign this assignment to yourself?</p>
          <div class="form-group">
            <label for="notes2" class="fs-">Notes*</label>
            <textarea formControlName="notes" id="notes" rows="4" placeholder="Enter your notes here."
              class="input_field" [ngClass]="{'is-invalid': assignToMeForm.get('notes')?.invalid && assignToMeForm.get('notes')?.touched}"></textarea>
            <p class="text-danger fs-10 fw-500" *ngIf="assignToMeForm.get('notes')?.invalid && assignToMeForm.get('notes')?.touched">
              * Please enter a note</p>
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end w-100">
          
              <button type="button" class="btn btn-outline me-2"
                (click)="cancel()">Cancel</button>
           
              <button type="submit" class="btn btn-primary" [disabled]="assignToMeForm.invalid">Assign</button>
            
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="modalType == _assignmentsService.modalTypes.deleteModal">
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="deleteForm" (ngSubmit)="handleDelete()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Delete Assignment</h4>
      <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
      </div>
        <div class="modal-body">
          <p>Are you sure you want to delete this assignment?</p>
          <div class="form-group">
            <label for="notes2" class="fs-14 fw-400 m-0">Notes*</label>
            <textarea formControlName="notes" trim="blur" id="notes" rows="4"
              placeholder="Enter your notes here." class="input_field"
              [ngClass]="{'is-invalid': deleteForm.get('notes')?.invalid && deleteForm.get('notes')?.touched}"></textarea>
            <p class="text-danger fs-10 fw-500" *ngIf="deleteForm.get('notes')?.invalid && deleteForm.get('notes')?.touched">* Please
              enter a note</p>
          </div>
        </div>
        <div class="modal-footer">
          <div class="text-end">
              <button type="button" class="btn btn-outline me-3"
                (click)="cancel()">No</button>
              <button type="submit" class="btn btn-primary"
                [disabled]="deleteForm.invalid">Yes</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="modalType == _assignmentsService.modalTypes.ticketAssignToMeModal">
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="phaseAssignToMeForm" (ngSubmit)="assignTicket()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
            <h4 class="modal-title text-white fs-18">Assign To</h4>
            <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
        </div>
        
        <div class="modal-body">
          <div class="d-flex align-items-center">
            <span class="pe-2 fs-14 fw-400 m-0" >Change Full Details</span>   
            <label class="switch switch-md switch-success vertical-bottom">
              <input 
                type="checkbox" 
                [checked]="only_assign_button" 
                (change)="changeToggle($event)" 
                name="only_assign_button"
              />
              <span class="slider"></span>
            </label>
            <span class="ps-2 fs-14 fw-400 m-0">Change Only Assignee</span>
          </div>
          <div class="form-group" *ngIf="!only_assign_button">
              <label for="status"  class="fs-14 fw-400 m-0">Status</label>
              <select formControlName="status" name="status" id="status" required
                class="input_field">
                <option value="" disabled>Please Select</option>
                <option value="0">Pending</option>
                <option value="3">Follow Up</option>
              </select>
          </div>

            <div class="form-group row" *ngIf="phase_extra_data.status != 1">
                <div class="col"  *ngIf="!only_assign_button">
                  <label for="" class="fs-14 fw-400 m-0">Follow Date* </label>
                  <div class="d-flex align-items-center input_field p-0 overflow-hidden">
                    <input required formControlName="followupDate" name="followupDate"
                      class="input_field border-0 border-end m-0 flex-fill rounded-0" bsDatepicker readonly #dp="bsDatepicker" [bsConfig]="dateConfig" [minDate]="minDate"
                     placeholder="Choose a date">
                    <div class="bg-transparent border-0 h-100 hw-40 d-flex align-items-center justify-content-center" (click)="dp.toggle()">
                      <i class="fa fa-calendar"></i>
                    </div>
                  </div>
                  <p class="text-danger fs-10 fw-500" *ngIf="phaseAssignToMeForm.get('followupDate')?.invalid && phaseAssignToMeForm.get('followupDate')?.touched">Please
                    select follow up date.</p>
                </div>
                <div class="col"  *ngIf="!only_assign_button">
                  <label for="" class="fs-14 fw-400 m-0 mb-2">Followup Time({{timezoneName}})*
                    <i class="ms-1 fa fa-info-circle" tooltip="Please set followup time in 24 hour format."></i>
                  </label>
                  <div class="row">
                    <div class="col-6">
                      <ngx-select [items]="hours" optionValueField="value" optionTextField="value" name="value"
                        [allowClear]="false" placeholder="HH" formControlName="followup_hour">
                        <ng-template ngx-select-option-selected let-option>
                          {{option.data.value}}
                        </ng-template>
                        <ng-template ngx-select-option-not-found>
                          Not found
                        </ng-template>
                      </ngx-select>
                    </div>
                    <div class="col-6">
                      <ngx-select [items]="minutes" optionValueField="value" optionTextField="value" name="value"
                        [allowClear]="false" placeholder="MM" formControlName="followup_minutes">
                        <ng-template ngx-select-option-selected let-option>
                          {{option.data.value}}
                        </ng-template>
                        <ng-template ngx-select-option-not-found>
                          Not found
                        </ng-template>
                      </ngx-select>
                    </div>
                  </div>
                </div>
            </div>
            <div class="form-group" *ngIf="phase_extra_data.status != 1">
              <label for=""  class="fs-14 fw-400 m-0 mb-2">Assign To</label>
              <ngx-select [items]="admin_list" name="admin_assign" optionValueField="admin_id" optionTextField="admin_name"
                (select)="selectAssignedAdmin($event)" [allowClear]="true" (selectionChanges)="assignedAdminClear($event)" placeholder="please enter assign to">
                <ng-template ngx-select-option-selected let-option>
                  {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
                </ng-template>
                <ng-template ngx-select-option let-option let-text="text">
                  {{option.data.admin_name}} <br>
                  <small>{{option.data.admin_email}}</small>
                </ng-template>
                <ng-template ngx-select-option-not-found>
                  Not found
                </ng-template>
              </ngx-select>
            </div>
            <div class="form-group">
              <label for="notes2"  class="fs-14 fw-400 m-0">Notes*</label>
              <textarea required name="notes" trim="blur" id="notes" rows="4" placeholder="Enter your notes here." class="input_field"
                [ngClass]="{'is-invalid':phaseAssignToMeForm.get('notes')?.invalid && phaseAssignToMeForm.get('notes')?.touched}" formControlName="notes"></textarea>
              <p class="text-danger fs-10 fw-500" *ngIf="phaseAssignToMeForm.get('notes')?.invalid && phaseAssignToMeForm.get('notes')?.touched">* Please
                enter a note</p>
            </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-outline me-2"
              (click)="cancel()">Cancel</button>
              <button type="submit" class="btn btn-primary"  [disabled]="phaseAssignToMeForm.invalid">Assign</button>
           
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<!--Approve Reject-->
<ng-container *ngIf="modalType == _assignmentsService.modalTypes.approveRejectModal">
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="approveForm" (ngSubmit)="handleApproveReject()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18" *ngIf="approve_extra_data">{{approve_extra_data.is_approved == 1?'Approve':'Reject'}}</h4>
      <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
      </div>
        <div class="modal-body" *ngIf="approve_extra_data">
          <div class="form-group">
            <label for="">Assign To</label>
            <ngx-select [items]="admin_list" optionValueField="admin_id" optionTextField="admin_name"
              (select)="selectAssignedAdmin($event)" [allowClear]="true" (selectionChanges)="assignedAdminClear($event)"
              placeholder="please enter assign to" formControlName="admin_id"
              name="assigned_to">
              <ng-template ngx-select-option-selected let-option>
                {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
              </ng-template>
              <ng-template ngx-select-option let-option let-text="text">
                {{option.data.admin_name}} <br>
                <small>{{option.data.admin_email}}</small>
              </ng-template>
              <ng-template ngx-select-option-not-found>
                Not found
              </ng-template>
            </ngx-select>
          </div>
          <div class="form-group">
            <label for="notes2">Notes</label>
            <textarea required name="notes" trim="blur" id="notes" rows="4"
              formControlName="notes" placeholder="Enter your notes here."
              class="input_field"
              [ngClass]="{'is-invalid':approveForm.get('notes')?.invalid && approveForm.get('notes')?.touched}"></textarea>
            <p class="text-danger fs-10 fw-500" *ngIf="approveForm.get('notes')?.invalid && approveForm.get('notes')?.touched">*
              Please enter a
              note</p>
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-between" style="width:100%;">
            <div class="flex-1">
              <button type="button" class="btn btn-outline"
                (click)="cancel()">Cancel</button>
            </div>
            <div class="flex-2">
              <button type="submit" class="btn btn-primary" (click)="approveForm.valid"
                [disabled]="approveForm.invalid">Confirm</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>


<!--Change Status-->
<ng-container *ngIf="modalType == _assignmentsService.modalTypes.changeStatusModal">
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="changeStatusForm" (ngSubmit)="changeStatus()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Change Status / Reassign</h4>
      <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
      </div>
        <div class="modal-body" *ngIf="change_status_data">
          <div class="form-group">
            <label for="status" class="fs-14 fw-400 m-0">Status</label>
            <select name="status" id="status" required formControlName="status" 
              class="input_field" [ngClass]="{'is-invalid':changeStatusForm.get('status')?.invalid && changeStatusForm.get('status')?.touched}" [(ngModel)]="change_status_data.status">
              <option value="" disabled selected>Please Select</option>
              <option value="0" *ngIf="change_status_data.status == 0 && change_status_data.action_type != 'bankruptcy'">Pending</option>
              <option value="1"
                *ngIf="!change_status_data.phase_req_id || (change_status_data.phase_req_id && (change_status_data.role == 1 ||change_status_data.role == 4 || change_status_data.role == 9 || change_status_data.role == 12 || change_status_data.role == 13 || change_status_data.role == 7))">
                Closed
              </option>
              <option value="2" *ngIf="change_status_data.action_type != 'bankruptcy'">Re-Open</option>
              <option value="3">Follow Up</option>
            </select>
          </div>
          <div class="form-group row" *ngIf="change_status_data?.status != 1">
            <div class="col">
              <label for="type_of_call" class="fs-14 fw-400 m-0">Type of Contact</label>
              <select name="t_o_c" id="t_o_c" class="input_field" formControlName="type_of_call" (change)="updateField('type_of_call', $event)" >
                <option value="0" selected disabled >Select Contact Type</option>
                <option *ngFor="let t_o_c of change_status_data.type_of_call_arr" [value]="t_o_c.contact_id">{{t_o_c.contact_name}}</option>
              </select>
            </div>
            <div class="col" *ngIf="![6, 7, 8].includes(change_status_data?.type_of_call)">
              <label for="result_of_contact" class="fs-14 fw-400 m-0">Result of contact</label>
              <select name="r_o_c" id="r_o_c" class="input_field" formControlName="result_of_contact" (change)="updateField('result_of_contact', $event)" [disabled]="!change_status_data.type_of_call || change_status_data.type_of_call == '9' ">
                <option value="0" selected disabled >Select Contact Result</option>
                <option *ngFor="let r_o_c of change_status_data.result_of_contact_arr" [value]="r_o_c.result_id">{{r_o_c.result_value}}</option>
              </select>
            </div>
          </div>
          <div class="form-group row" *ngIf="change_status_data.status != 1">
            <div class="col">
              <label for="" class="fs-14 fw-400 m-0">Follow Date*</label>
              <div class="input-group">
                <input required formControlName="followupDate" name="followupDate"
                  class="input_field" bsDatepicker [bsConfig]="dateConfig" [minDate]="minDate"
                  style="background: #ffffff;" placeholder="Choose a date">
                <div class="input-group-append">
                  <!-- <button type="button" (click)="bsDatepicker.toggle()" class="btn rounded"><i class="fa fa-calendar"></i></button> -->
                </div>
              </div>
              <p class="text-danger fs-10 fw-500" *ngIf="changeStatusForm.get('followupDate')?.invalid && changeStatusForm.get('followupDate')?.touched">Please
                select follow up date.</p>
            </div>
            <div class="col">
              <label for="" class="fs-14 fw-400 m-0">Followup Time({{timezoneName}})*
                <i class="ms-1 fa fa-info-circle" tooltip="Please set followup time in 24 hour format."></i>
              </label>
              <div class="row my-2">
                <div class="col-6">
                  <ngx-select [items]="hours" optionValueField="value" optionTextField="value" name="value"
                    [allowClear]="false" placeholder="HH" formControlName="followup_hour">
                    <ng-template ngx-select-option-selected let-option>
                      {{option.data.value}}
                    </ng-template>
                    <ng-template ngx-select-option-not-found>
                      Not found
                    </ng-template>
                  </ngx-select>
                </div>
                <div class="col-6">
                  <ngx-select [items]="minutes" optionValueField="value" optionTextField="value" name="value"
                    [allowClear]="false" placeholder="MM" formControlName="followup_minutes">
                    <ng-template ngx-select-option-selected let-option>
                      {{option.data.value}}
                    </ng-template>
                    <ng-template ngx-select-option-not-found>
                      Not found
                    </ng-template>
                  </ngx-select>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group" *ngIf="change_status_data.status != 1">
            <label for="" class="fs-14 fw-400 m-0 mb-2">Assign To</label>
            <ngx-select [items]="admin_list" optionValueField="admin_id" optionTextField="admin_name" name="admin_name"
              (select)="selectAssignedAdmin($event)" [allowClear]="true" (selectionChanges)="assignedAdminClear($event)"
              placeholder="please enter assign to" formControlName="admin_id">
              <ng-template ngx-select-option-selected let-option>
                {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
              </ng-template>
              <ng-template ngx-select-option let-option let-text="text">
                {{option.data.admin_name}} <br>
                <small>{{option.data.admin_email}}</small>
              </ng-template>
              <ng-template ngx-select-option-not-found>
                Not found
              </ng-template>
            </ngx-select>
          </div>

          <div class="form-group">
            <label for="notes" class="fs-14 fw-400 m-0">Notes</label>
            <textarea [ngClass]="{'is-invalid':changeStatusForm.get('notes')?.invalid && changeStatusForm.get('notes')?.touched}" required name="notes"
              id="notes" rows="4" formControlName="notes"
              placeholder="Enter your notes here." class="input_field" trim="blur"></textarea>
            <p class="text-danger fs-10 fw-500" *ngIf="changeStatusForm.get('notes')?.invalid && changeStatusForm.get('notes')?.touched">* Please enter
              a note</p>
          </div>

          <div class="col p-0">
            <div class="text-end">
              <label for="images" class="btn btn-link p-0">Attach Image/Document</label>
              <input type="file" name="" id="images" #imageElement
                accept=".gif, .jpeg, .jpg, .png, .doc,.docx,application/msword, .pdf, .xls,.xlsx, .csv"
                (change)="fileSelect($event)" class="d-none">
            </div>
            <div *ngFor="let file of images; let i=index">
              <div *ngIf="file.subs && file.subs[0]">
                <div class="d-flex" *ngIf="file.subs[0].message">
                  <progressbar [value]="file.subs[0].message" type="warning" [striped]="true">
                    {{file.subs[0].message}}%</progressbar>
                  <i class="fa fa-close ms-2" tappable tooltip="Cancel upload" (click)="cancelImageUpload(file, i)"></i>
                </div>
                <div *ngIf="file.subs[0].images && file.subs[0].images[0]"
                  class="d-flex justify-content-between align-items-center border mb-1">
                  <span class="d-flex align-items-center ">
                    <i class="fa fa-trash text-danger fs-10 fw-500 px-2 pointer " (click)="deleteFile(file.image, i)"
                      tooltip="Delete uploaded file" tappable></i>
                    <a [href]="file.image" target="_blank">Click here to view</a>
                  </span>
                  <i class="fa fa-check text-success" tooltip="File Uploaded"></i>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col pr-1">
                <button type="button" class="btn btn-default" (click)="cancel()">No</button>
            </div>
            <div class="col">
              <button type="submit" class="btn btn-primary" (click)="changeStatusForm.valid" [disabled]="changeStatusForm.invalid || change_status_data.uploading">Yes</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="modalType == _assignmentsService.modalTypes.addNoteModal">
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="addNoteForm" (ngSubmit)="addNote()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Add Notes</h4>
      <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
      </div>
        <div class="modal-body" *ngIf="change_status_data">
          <div class="form-group">
            <label for="notes" class="fs-14 fw-400 m-0">Notes</label>
            <textarea required name="notes" id="notes" rows="4" formControlName="notes"
              placeholder="Enter your notes here." class="input_field"
              [ngClass]="{'is-invalid':addNoteForm.get('notes')?.invalid && addNoteForm.get('notes')?.touched}"></textarea>
            <p class="text-danger fs-10 fw-500" *ngIf="addNoteForm.get('notes')?.invalid && addNoteForm.get('notes')?.touched">* Please enter a
              note</p>
          </div>

          <div class="col p-0">
            <div class="text-end">
              <label for="images" class="btn btn-primary btn-sm rounded">Attach Image/Document</label>
              <input type="file" name="" id="images" #imageElement
                accept=".gif, .jpeg, .jpg, .png, .doc,.docx,application/msword, .pdf, .xls,.xlsx, .csv"
                (change)="fileSelect($event)" class="d-none">
            </div>

            <div *ngFor="let file of images; let i=index">
              <div *ngIf="file.subs && file.subs[0]">
                <div class="d-flex" *ngIf="file.subs[0].message">
                  <progressbar [value]="file.subs[0].message" type="warning" [striped]="true">
                    {{file.subs[0].message}}%</progressbar>
                  <i class="fa fa-close ms-2" tappable tooltip="Cancel upload" (click)="cancelImageUpload(file, i)"></i>
                </div>
    
    
                <div *ngIf="file.subs && file.subs[0].images && file.subs[0].images[0]"
                  class="d-flex justify-content-between align-items-center border mb-1">
                  <span>
                    <i class="fa fa-trash text-danger me-2" (click)="deleteFile(file.subs[0].images[0], i)"
                      tooltip="Delete uploaded file" tappable></i>
                    <a [href]="file.subs[0].images[0]" target="_blank">Click here to view</a>
                  </span>
                  <i class="fa fa-check text-success" tooltip="File Uploaded"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer text-end">
            <div>
              <button type="submit" class="btn btn-primary" (click)="addNoteForm.valid"
                [disabled]="addNoteForm.invalid || change_status_data.uploading">Add</button>
            </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>


<!-- Udpate assignment inquiry-->
<ng-container *ngIf="modalType == _assignmentsService.modalTypes.updateInformationInquiryModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content border-0" *ngIf="update_extra_data && update_extra_data.wp_query_id">
      <form [formGroup]="updateForm" (ngSubmit)="updateInquiry()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Update Inquiry Information</h4>
      <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
      </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="name">Name*</label>
              <input type="text" required name="wp_name" trim="blur" id="wp_name" formControlName="wp_name"
                placeholder="Enter name" class="input_field">
              <p class="text-danger fs-10 fw-500" *ngIf="updateForm.get('wp_name')?.invalid && updateForm.get('wp_name')?.touched">* Please enter name
              </p>
            </div>
            <div class="form-group col-md-6">
              <label for="email">Email*</label>
              
              <input formControlName="wp_email" email required
                name="wp_email" class="input_field" type="email" autocomplete="none">
              <p class="text-danger fs-10 fw-500" *ngIf="updateForm.get('wp_email')?.invalid && updateForm.get('wp_email')?.touched">* Please enter
                email</p>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="phone">Phone*</label>
              
              <input type="text" required class="input_field" id="wp_phone" name="wp_phone"
                placeholder="Enter phone." formControlName="wp_phone" />
              <p class="text-danger fs-10 fw-500" *ngIf="updateForm.get('wp_phone')?.invalid && updateForm.get('wp_phone')?.touched">* Please enter
                phone</p>
            </div>

            <div class="form-group col-md-6">
              <label for="phone">Specialty* </label>
              <select name="wp_speciality" id="wp_speciality" formControlName="wp_speciality"
                class="input_field">
                <option value="0" selected>All</option>
                <optgroup *ngFor="let ind of update_extra_data.industries" label="{{ind.ind_name}}">
                  <option *ngFor="let spec of ind.specialities" [value]="spec.speciality_name">{{spec.speciality_name}}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>

          <div class="form-group col-md-6">
            <label for="wp_zip">Zip*</label>
            <input type="text" readonly required name="wp_zip" trim="blur" id="wp_zip"
                formControlName="wp_zip" class="input_field">
          </div>
          <div class="form-group col-md-6">
            <label for="wp_address">Address*</label>
            <app-google-zip class="w-100" (setAddress)="selectZip($event)"
                id="wp_address" [country_code]="country_code"
                [address]="update_extra_data.assignment.wp_address">
            </app-google-zip>
          </div>


          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="city">City*</label>
              <input type="text" readonly required name="wp_city_name" trim="blur" id="wp_city_name"
                formControlName="wp_city_name" class="input_field">
            </div>

            <div class="form-group col-md-6">
              <label for="start">State*</label>
              <input type="text" readonly required name="wp_state_name" trim="blur" id="wp_state_name"
                formControlName="wp_state_name" placeholder="Enter notes here."
                class="input_field">
            </div>
          </div>

          <div class="form-row">
            
            <div class="form-group col-md-12">
              <label for="travel">Can travel upto miles*</label>
              <input type="text" required name="wp_distance" trim="blur" id="wp_distance"
                formControlName="wp_distance" class="input_field">
              <p class="text-danger fs-10 fw-500" *ngIf="updateForm.get('wp_distance')?.invalid && updateForm.get('wp_distance')?.touched">* Please
                enter travel upto</p>
            </div>

          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="notes2">Message*</label>
              <textarea type="text" required name="wp_message" trim="blur" id="wp_message" rows="4"
                formControlName="wp_message" placeholder="Enter your notes here."
                class="input_field"></textarea>
              <p class="text-danger fs-10 fw-500" *ngIf="updateForm.get('wp_message')?.invalid && updateForm.get('wp_message')?.touched">*
                Please enter a note</p>
            </div>

            <div class="form-group col-md-6">
              <label for="notes2">Notes*</label>
              <textarea type="text" required name="update_note" trim="blur" id="update_note" rows="4"
                formControlName="update_note" placeholder="Enter your notes here."
                class="input_field"></textarea>
              <p class="text-danger fs-10 fw-500" *ngIf="updateForm.get('update_note')?.invalid && updateForm.get('update_note')?.touched">*
                Please enter a note</p>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-between" style="width:100%;">
            <div class="flex-1">
              <button type="button" class="btn btn-outline"
                (click)="cancel()">Cancel</button>
            </div>
            <div class="flex-2">
              <button type="submit" [disabled]="updateForm.invalid" class="btn btn-primary">Confirm</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="modalType == _assignmentsService.modalTypes.viewDocuments">
  <div class="modal-dialog modal-lg">
    <div class="modal-content border-0" >
      <form>
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Documents Uploaded By Business</h4>
      <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
      </div>
        <div class="modal-body">
          <ul class="decoration-none  p-0">
            <li>
              <h3 class="fw-500 text-muted" *ngIf="uploaded_doc && uploaded_doc.length > 0">Uploaded Documents</h3>
              <ol>
                <li *ngFor="let item of uploaded_doc;let i = index" class="mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <a [href]="item.doc_url" target="_blank" class="fs-14  fw-500 m-0">
                      {{item.document_name}} <span *ngIf="item.show_document == 1">( Old Document )</span>
                    </a>
                    <div class="" *ngIf="needMore && item.show_document != 1 && item.need_more_document != 1">
                      <input class="secondary-checkbox" type="checkbox" value="0" [id]="'doc1'+ i"><label tappable
                        class="fs-14 fw-400 m-0" [for]="'doc1'+ i" (click)="toggleSelect(i,1)" style="
    transform: translateY(-13px);
"></label>
                    </div>
                  </div>

                  <div class=" btn-group w-100" dropdown *ngIf="item.selected && needMore">
                    <button id="button-basic" dropdownToggle type="button"
                      class="w-100 border radius-4 px-3 py-1 bg-white d-flex align-items-center justify-content-between dropdown-toggle"
                      aria-controls="dropdown-basic">
                      {{item.reason || "Select Reason"}}
                      <span class="caret"></span>
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu cursor" role="menu" aria-labelledby="button-basic">
                      <li role="menuitem" class="px-2" *ngFor="let item of reasons;let t = index" (click)="selectedReason(t,i,1)">
                        {{t+1}}. {{item.reason_value}}
                      </li>          
                    </ul>
                  </div>
                </li>
              </ol>
            </li>
            <li *ngIf="document_data.assignment_detail.status != 1 && remaining_doc.length > 0">
              <h3 class="fw-500 text-muted">Remaining Documents</h3>
              <ol>
                <li *ngFor="let item of remaining_doc;let i = index" class="mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <p class="fs-14  fw-500 m-0">
                      {{item.document_name}}
                    </p>
                    <div class="" *ngIf="needMore">
                      <input class="secondary-checkbox" type="checkbox" value="0" [id]="'doc'+ i"><label tappable
                        class="fs-14 fw-400 m-0" [for]="'doc'+ i" (click)="toggleSelect(i,2)"></label>
                    </div>
                  </div>
                </li>
              </ol>
            </li>         
          
          </ul>
          <textarea name="notes" id="notes" rows="4"  [(ngModel)]="note"
          placeholder="Enter your notes here." class="input_field" *ngIf="document_data.assignment_detail.status != 1"></textarea>
        </div>
        <div class="modal-footer d-flex align-items-center justify-content-between" *ngIf="document_data.assignment_detail.status != 1">
          <button type="button" class="btn btn-primary" (click)="needMore = !needMore" *ngIf="show_need_more_document && !needMore">Need More Documents</button> 
          <button type="submit" class="btn btn-primary" (click)="needMore = !needMore;disSelectALL()" *ngIf="needMore" >Back</button>       
          <button type="submit" class="btn btn-primary" (click)="approveOrNeedMoreDocument(1)" *ngIf="!needMore" >Approve</button>   
          <button type="submit" class="btn btn-primary" (click)="approveOrNeedMoreDocument(2)" *ngIf="needMore" >send</button>      
        </div>
      </form>
    </div>
  </div>
</ng-container>
<!-- View SSN  -->

<!-- <ng-container *ngIf="modalType == _assignmentsService.modalTypes.viewFullSSN">
    <div class="modal-dialog modal-md  modal-dialog-centered customModal">
        <div class="modal-content border-0">
            <form [formGroup]="viewFullSSNForm" (ngSubmit)="viewFullSSN()">
                <div class="modal-body">
                    <div class="d-flex justify-content-between mb-4">
                        <h4 class="modal-title">
                            View Complete SSN
                        </h4>
                        <button type="button" class="close" aria-label="Close" (click)="hide()">&times;</button>
                    </div>
                    <div class="col-12 pl-0">
                        <div class="form-group mb-3">
                            <input type="password" class="form-control" placeholder="Admin password"
                                formControlName="password">
                            <p *ngIf="viewFullSSNForm.controls['password'].invalid && viewFullSSNForm.controls['password'].touched"
                                class="text-danger">
                                Please enter a valid password
                            </p>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end mt-3">
                        <button class="btn btn-primary" type="submit" [disabled]="!viewFullSSNForm.valid">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-container> -->

<ng-container *ngIf="modalType == _assignmentsService.modalTypes.viewFullSSN">
    <div class="modal-dialog modal-md  modal-dialog-centered customModal">
        <div class="modal-content border-0">
            <form [formGroup]="viewFullSSNForm" (ngSubmit)="viewFullSSN()">
                <div class="modal-body">
                    <div class="d-flex justify-content-between mb-4">
                        <h4 class="modal-title">
                            View Complete SSN
                        </h4>
                        <button type="button" class="close" aria-label="Close" (click)="hide()">&times;</button>
                    </div>
                    <div class="col-12 pl-0">
                        <div class="form-group mb-3">
                            <input type="password" class="form-control" placeholder="Admin password"
                                formControlName="password">
                            <p *ngIf="viewFullSSNForm.controls['password'].invalid && viewFullSSNForm.controls['password'].touched"
                                class="text-danger">
                                Please enter a valid password
                            </p>
                        </div>
                        <div class="form-group mt-1">
                            <label>Notes*</label>
                            <textarea class="mt-1 form-control " name="notes" formControlName="notes"
                                placeholder="Enter notes here" rows="4"></textarea>
                        </div>

                    </div>
                    <div class="d-flex justify-content-end mt-3">
                        <button class="btn btn-primary" type="submit" [disabled]="!viewFullSSNForm.valid">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="modalType == _assignmentsService.modalTypes.businessDocs">
  <div class="modal-dialog modal-lg">
    <div class="modal-content border-0" >
      <form>
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Documents Uploaded By Business</h4>
      <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
      </div>
        <div class="modal-body">
          <ul class="decoration-none  p-0">
            <li>
              <h3 class="fw-500 text-muted" *ngIf="business_uploaded_doc && business_uploaded_doc.length > 0">Uploaded Documents</h3>
              <ol>
                <li *ngFor="let item of business_uploaded_doc;let i = index" class="mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <a [href]="item" target="_blank" class="fs-14  fw-500 m-0">
                      {{item}}
                    </a>
                  </div>
                </li>
              </ol>
            </li>       
          </ul>
        </div>
      </form>
    </div>
  </div>
</ng-container>
